import { useEffect, useState, useRef } from "react"
import { useSelector } from "react-redux"
import moment from "moment"
import * as customerActivityApis from "../../utilities/apis/customer_activity"
import { getCustomerActivityType } from "../../utilities/enumerations/constants"
import Layout from "../../components/Layout"
import Pagination from "../../components/Pagination"

const CustomerActivities = () => {
  const { token } = useSelector(state => state.user)
  const [customerActivities, setCustomerActivities] = useState([])
  const typeRef = useRef(null)
  const fromRef = useRef(null)
  const toRef = useRef(null)
  const [active, setActive] = useState(1)
  const [count, setCount] = useState(0)
  const [filters, setFilters] = useState({
    limit: 10,
    offset: 0,
  })

  const handleSearch = () => {
    const where = {}

    if (typeRef.current.value) where.type = typeRef.current.value
    if (fromRef.current.value) where.from = moment(fromRef.current.value).startOf("day").format()
    if (toRef.current.value) where.to = moment(toRef.current.value).endOf("day").format()

    setFilters({ limit: filters.limit, offset: 0, ...where })
    setActive(1)
  }

  const handleReset = () => {
    setFilters({ limit: 10, offset: 0 })
    typeRef.current.value = ""
    fromRef.current.value = ""
    toRef.current.value = ""
    setActive(1)
  }

  const getCustomerActivities = async () => {
    try {
      const query = new URLSearchParams(filters)
      const response = await customerActivityApis.getCustomerActivities(token, query.toString())
      if (!response.status) throw new Error(response.message)

      setCount(response.count)
      setCustomerActivities(response.customer_activities)
    } catch (error) {
      alert(error.message)
    }
  }

  const handlePageChange = (page, offset) => {
    setFilters({ ...filters, offset })
    setActive(page)
  }

  useEffect(() => {
    getCustomerActivities()
  }, [filters])

  return (
    <Layout
      header={true}
      footer={true}
    >
      <main className="py-3">
        <div className="w-75 mx-auto">
          <div className="d-flex justify-content-between align-items-center mb-3">
            <p className="lead text-body-emphasis fw-bold m-0">Customer Activity</p>
          </div>

          <div className="border rounded-4 mb-3">
            <div className="p-3 border-bottom rounded-top-4 bg-secondary">
              <div className="row g-2">
                <div className="col-md-2">
                  <select ref={typeRef} className="form-select form-select-sm rounded-3" id="type" defaultValue="">
                    <option value="">All Types</option>
                    {Object.keys(getCustomerActivityType).map((type) => (
                      <option key={type} value={type}>{type.replace(/\b\w/g, (c) => c.toUpperCase())}</option>
                    ))}
                  </select>
                </div>
                <div className="col-md-2">
                  <input ref={fromRef} type="date" className="form-control form-control-sm rounded-3" id="from" title="From" />
                </div>
                <div className="col-md-2">
                  <input ref={toRef} type="date" className="form-control form-control-sm rounded-3" id="to" title="To" />
                </div>
                <div className="col-md-4" />
                <div className="col-md-2">
                  <div className="d-flex justify-content-end gap-2">
                    <button type="button" className="btn btn-sm btn-light-theme rounded-3" onClick={handleSearch}><i className="fas fa-search me-2"></i> Search</button>
                    <button type="reset" className="btn btn-sm btn-light-danger rounded-3" onClick={handleReset}><i className="fas fa-times me-2"></i> Clear</button>
                  </div>
                </div>
              </div>
            </div>
            <table className="table table-hover shadow-none m-0">
              <thead className="table-light">
                <tr>
                  <th scope="col" style={{ width: "10%" }} className="align-middle text-center">S. No.</th>
                  <th scope="col" style={{ width: "25%" }} className="align-middle">Customer</th>
                  <th scope="col" style={{ width: "15%" }} className="align-middle">Activity</th>
                  <th scope="col" style={{ width: "25%" }} className="align-middle">Product / Deal</th>
                  <th scope="col" style={{ width: "10%" }} className="align-middle">Source</th>
                  <th scope="col" style={{ width: "15%" }} className="align-middle">Date</th>
                </tr>
              </thead>
              <tbody>
                {customerActivities.map((row) => {
                  return (
                    <tr key={row.id.toString()}>
                      <td className="align-middle text-center">{row.id}</td>
                      <td className="align-middle">
                        <p className="m-0">{row.customer?.name}</p>
                        <small className="text-muted">{row.customer?.mobile}</small>
                      </td>
                      <td className="align-middle">{getCustomerActivityType[row.type] || row.type}</td>
                      <td className="align-middle">{row.product?.name || row.deal?.name}</td>
                      <td className="align-middle text-uppercase">{row.source}</td>
                      <td className="align-middle">{moment(row.created_at).format("DD-MM-YYYY HH:mm")}</td>
                    </tr>
                  )
                })}
              </tbody>
            </table>
          </div>

          <nav aria-label="pagination">
            <Pagination
              currentPage={active}
              totalCount={count}
              pageSize={filters.limit}
              offset={filters.offset}
              siblingCount={3}
              onPageChange={handlePageChange}
            />
          </nav>
        </div>
      </main>
    </Layout>
  )
}

export default CustomerActivities
